import {
    getMethod,
    postMethod,
    putMethod,
    deleteMethod
} from "../../api-service/api-service";

import {
    setPortfolios,
    setSelectedPortfolio,
    addPortfolio,
    updatePortfolio as updatePortfolioReducer,
    removePortfolio as removePortfolioReducer
} from "./portfolioSlice";

/**
 * GET ALL
 */
export const fetchAllPortfolioAction = () => async (dispatch) => {
    try {
        const response = await getMethod('/portfolio');

        if (response?.success) {
            dispatch(setPortfolios(response.data));
        }

        return response;
    } catch (error) {
        console.log("Error: ", error);
        return { success: false };
    }
};

/**
 * GET DETAILS
 */
export const fetchPortfolioDetailsAction = (id) => async (dispatch) => {
    try {
        const response = await getMethod(`/portfolio/${id}`);

        if (response?.success) {
            dispatch(setSelectedPortfolio(response.data));
        }

        return response;
    } catch (error) {
        console.log("Error: ", error);
        return { success: false };
    }
};

/**
 * CREATE
 */
export const createPortfolioAction = (data) => async (dispatch) => {
    try {
        const response = await postMethod('/portfolio', data);

        if (response?.success) {
            dispatch(addPortfolio(response.data));
        }

        return response;
    } catch (error) {
        console.log("Error: ", error);
        return { success: false };
    }
};

/**
 * UPDATE
 */
export const updatePortfolioAction = (id, data) => async (dispatch) => {
    try {
        const response = await putMethod(`/portfolio/${id}`, data);

        if (response?.success) {
            dispatch(updatePortfolioReducer(response.data));
        }

        return response;
    } catch (error) {
        console.log("Error: ", error);
        return { success: false };
    }
};

/**
 * DELETE
 */
export const removePortfolioAction = (id) => async (dispatch) => {
    try {
        const response = await deleteMethod(`/portfolio/${id}`);

        if (response?.success) {
            dispatch(removePortfolioReducer(id));
        }

        return response;
    } catch (error) {
        console.log("Error: ", error);
        return { success: false };
    }
};
